import { Pool } from "@/models/pool.model";

/**
 * Taken from v1 codebase
 * regul.js GetSpeedCnt (line 627)
 */

const PUMP_WIRED = 0;
const PUMP_AQUAGEM = 1;
const PUMP_PENTAIR = 2;
const PUMP_NONE = 7;

function GetPumpType(currentPool: Pool) {
  return (currentPool.ExtraParams!.VFOutsCount >> 3) & 7;
}

function VF0IsOnOff(currentPool: Pool) {
  return !!((currentPool.ExtraParams!.VFSpeed1 >>> 31) & 1);
}

export default function getSpeedCount(currentPool: Pool) {
  if (
    currentPool.ExtraParams === undefined ||
    currentPool.ExtraParams.VFOutsCount === undefined
  )
    return 1;
  let SpeedCnt = currentPool.ExtraParams.VFOutsCount & 7;
  const PumpType = GetPumpType(currentPool);

  switch (PumpType) {
    case PUMP_WIRED:
      if (VF0IsOnOff(currentPool) && SpeedCnt > 1) SpeedCnt--;
      break;
    case PUMP_AQUAGEM:
    case PUMP_PENTAIR:
      if (VF0IsOnOff(currentPool) && SpeedCnt > 0) SpeedCnt--;
      break;
    default:
      SpeedCnt = 0;
      break;
  }
  return SpeedCnt;
}
